// extracted by mini-css-extract-plugin
export default {"menu":"menu-PvHsMM2nGvbdXCEEeVjl"};